/**
 * A link from one guide to another, in the reader's language.
 *
 * The guide texts are plain data, so they cannot ask which language they are
 * read in; this does, and turns "statement-and-due-dates" into
 * /guides/statement-and-due-dates or /es/guias/fecha-de-corte-y-fecha-limite-de-pago.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useI18n } from '../i18n';
import type { GuideId } from './types';

export function GuideLink({ to, children }: { to: GuideId; children: ReactNode }) {
  const { localePath } = useI18n();
  return <Link to={localePath(`/guides/${to}`)}>{children}</Link>;
}
